import React from "react"
import { Link } from "react-navi"
import { Navbar, NavbarBrand, NavbarToggler } from "reactstrap"
import { NavigateToOtherPortal, useSelector, userSelectors } from "swiipe.portal.shared"
import logo from "../../images/aera-logo.png"
import { useShowLoggedInMenus } from "../../services/authService"
import { layoutReducerActions, layoutSelectors } from "../../store/reducers/layoutReducer"
import { userRelationSelectors } from "../../store/reducers/userRelationReducer"
import useReduxDispatch from "../../store/useReduxDispatch"
import TrackedTimeCounter from "../trackedTime/TrackedTimeCounter"
import "./NavBar.scss"
import SwitchUserMenu from "./SwitchUserMenu"

const NavBar = () => {
    const showLoggedInMenus = useShowLoggedInMenus()
    const sidebarIsOpen = useSelector(layoutSelectors.navBarOpen)
    const userData = useSelector(userSelectors.userData)
    const currentUserRelation = useSelector(userRelationSelectors.currentUserRelation)
    const email = userData?.user.email ?? ""
    const dispatch = useReduxDispatch()

    return (
        <Navbar light id="top-navbar" toggleable="" className="d-flex justify-content-between">
            {showLoggedInMenus && (
                <NavbarToggler
                    className="d-sm-none"
                    onClick={(e) => {
                        e.preventDefault()
                        dispatch(layoutReducerActions.setNavBarOpen(!sidebarIsOpen))
                    }}
                    target="sidebar-collapse"
                    id="navbar-toggle-trigger"
                ></NavbarToggler>
            )}
            <NavbarBrand tag="div">
                <Link href="/" exact>
                    <img src={logo} />
                </Link>
            </NavbarBrand>
            {/* <LoginSessionInfo /> */}
            <TrackedTimeCounter />
            <div className="top-navbar__navigation-container">
                <div className="email">{email}</div>
                <NavigateToOtherPortal relationId={currentUserRelation?.id ?? ""} type="NavToPortal" />
            </div>
            <SwitchUserMenu />
        </Navbar>
    )
}

export default NavBar
